import { useState } from 'react';
import { Fingerprint, X, Smartphone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { registerBiometric, isPlatformAuthenticatorAvailable } from '../utils/biometric';

export default function BiometricSetupModal({ isOpen, onClose, token, onSuccess }) {
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSetup = async () => {
    setLoading(true);
    try {
      const deviceName = navigator.userAgent.includes('Android') 
        ? 'Android Gerät' 
        : navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('iPad')
          ? 'Apple Gerät'
          : 'Mein Gerät';
          
      await registerBiometric(token, deviceName);
      toast.success("Biometrische Anmeldung erfolgreich eingerichtet!");
      onSuccess?.();
      onClose();
    } catch (error) {
      console.error("Setup error:", error);
      if (!error.message?.includes("cancelled") && !error.message?.includes("aborted")) {
        toast.error(error.message || "Einrichtung fehlgeschlagen");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSkip = () => {
    // Remember that user skipped for this session
    sessionStorage.setItem('biometric_setup_skipped', 'true');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-md w-full p-6 relative animate-in fade-in zoom-in duration-200">
        <button
          onClick={handleSkip}
          className="absolute top-4 right-4 text-slate-400 hover:text-slate-600"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="text-center">
          <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Fingerprint className="w-8 h-8 text-white" />
          </div>
          
          <h2 className="text-xl font-bold text-slate-800 mb-2">
            Schneller anmelden
          </h2>
          
          <p className="text-slate-600 mb-6">
            Möchtest du dich zukünftig mit deinem Fingerabdruck oder Face ID anmelden? 
            Das ist schneller und sicherer als ein Passwort.
          </p>

          <div className="space-y-3">
            <Button
              onClick={handleSetup}
              disabled={loading}
              className="w-full h-12 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-lg"
            >
              <Fingerprint className="w-5 h-5 mr-2" />
              {loading ? "Einrichten..." : "Jetzt einrichten"}
            </Button>
            
            <button
              onClick={handleSkip}
              className="w-full text-slate-500 hover:text-slate-700 text-sm py-2"
            >
              Später einrichten
            </button>
          </div>

          <p className="text-xs text-slate-400 mt-4">
            Du kannst dies jederzeit in den Einstellungen ändern.
          </p>
        </div>
      </div>
    </div>
  );
}
